export enum EventSeverity {
    INFO = 1,
    WARNING = 2,
    ERROR = 3,
}